
import { Button } from 'semantic-ui-react';

import styles from './index.module.css';

const Popup = ({ message, onClose, attendanceFormUrl  }: any) => {
      return (
        <div className={styles.popupOverlay}>
            <div className={styles.popupContainer}>
                <button
                    onClick={onClose}
                    className={styles.closeButton}
                    aria-label="Close popup"
                >
                <svg className={styles.closeIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
                </button>

                <div className={styles.popupContent}>
                <p className={styles.popupMessage}>{message}</p>
                <div className={styles.buttonContainer}>
                    <a className={styles.doItNowButton}  href={attendanceFormUrl} onClick={onClose} >
                        Do it now
                    </a>
                    <Button
                        onClick={onClose}
                        className={styles.doItLaterButton}
                    >
                        Do it later
                    </Button>
                </div>
                </div>
            </div>
        </div>
      );
};

export { Popup }
